import React from 'react';
import { Navbar, Footer } from './components/layout/Layout';
import { Hero } from './components/sections/Hero';
import { Testimonials, Problems, TargetAudience } from './components/sections/SocialProof';
import { Modules } from './components/sections/Modules';
import { Bonuses } from './components/sections/Bonuses';
import { Comparison } from './components/sections/Comparison';
import { PricingSection } from './components/sections/Pricing';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { PurchaseToast } from './components/ui/PurchaseToast';
import { PlanProvider } from './components/ui/PlanContext';
import { useScreenInit } from './useScreenInit';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useScreenInit();
  useMetaPixel();
  return <PlanProvider data-id="element-0">
      <div className="min-h-screen bg-negro text-blanco font-sans selection:bg-cyan/30 selection:text-cyan" data-id="element-1">
        <Navbar data-id="element-2" />

        <main data-id="element-3">
          <Hero data-id="element-4" />
          <Testimonials data-id="element-5" />
          <Problems data-id="element-6" />
          <TargetAudience data-id="element-7" />
          <Modules data-id="element-8" />
          <Bonuses data-id="element-9" />
          <Comparison data-id="element-10" />
          <PricingSection data-id="element-11" />
          <Faq data-id="element-12" />
          <FinalCta data-id="element-13" />
        </main>

        <Footer data-id="element-14" />

        <PurchaseToast data-id="element-15" />
      </div>
    </PlanProvider>;
}